/* Project Import will be here */
import { post, IRequest } from "./index";
import { ISecurityKeyGenerationParams } from "models/dmsPaymentModels";
import { IDmsRequestParams, IDmsHashGenerationRequest } from "models/dmsPaymentModels";
/* Project Import will be here */

/* Get Access token for DMS */
export const getSecurityKeyGenerationApi = (data: ISecurityKeyGenerationParams) => {
    const request: IRequest = {
        subUrl: `/S2SAuthentication/Authenticate`,
        data
    };

    return post(request, false);
};

/* Get pending invoice list from DMS server */
export const getDMSPendingInvoiceListApi = (data: IDmsRequestParams) => {
    const request: IRequest = {
        subUrl: `/PendingInvoice/Masters`,
        data
    };

    return post(request);
};

/* Get paid invoice list from DMS server */
export const getDMSPaidInvoiceListApi = (data: IDmsRequestParams) => {
    const request: IRequest = {
        subUrl: `/PaidInvoice/Masters`,
        data
    };

    return post(request);
};

/* Hash generation API */
export const getDmsHashGenerationApi = (data: IDmsHashGenerationRequest) => {
    const request: IRequest = {
        subUrl: `/GenerateMPQR/GetHash`,
        data
    };

    return post(request);
};